module.exports = __webpack_public_path__ + "img/vip-video.4a26a96a.png";